import ReactGA from 'react-ga';

export const analyticsService = {
  initializeGA: data => Promise.resolve( ReactGA.initialize( {trackingId: data.trackingId})),
  initializeGACommon: data => Promise.resolve( window.ga('create', data.trackingId,'auto', 'commonTracker')),
  sendEvent: data => Promise.resolve( ReactGA.event( data.data, data.names ) ),
  sendPageView: data => Promise.resolve( ReactGA.pageview( data.page, data.names, data.title ) ),
  set: data => Promise.resolve( ReactGA.set( data.data, data.names )  )
};